module.exports = __webpack_public_path__ + "img/2.40e20c99.png";